import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { MdOutlineLogout } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { Navbar, Container, Offcanvas, Nav } from "react-bootstrap";
import MBOTLogo from "../assets/logo/adminpannel_logo.png";
import Account from "../assets/misc/account.png";
import DonwlodButton from "../components/buttons/DonwlodButton";
import DateRangePicker from "../components/DatePicker/DateRangePicker";
import { sidebarItems } from "../data/Sidebar";
import useLogout from "../hooks/useLogout";
import { useDispatch } from "react-redux";
import { handleResetApplicationStatus, handleCertificateStatus, handleCurrentPage, handleProfileInformationType } from "../redux/slices/newApplicantsSlice";
import { setIDforStatusChange } from "../redux/slices/generalSlice";
import { handleCPDCertificateStatus, handleCurrentPage as handleCurrentPageTableSlice } from "../redux/slices/tablesSlice";
import { CERTIFICATE_TYPE } from "../data/NewApplicantsConstants";

const MasterLayout = ({ children }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [openDropdown, setOpenDropdown] = useState(false);
    const navigate = useNavigate();
    const { handleLogOut } = useLogout();
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const handleDropdownClick = () => {
        setOpenDropdown(!openDropdown);
        navigate("/reports/new-applicants");
    };

    const handleItemClick = (path) => {
        if(path === "/renewals" || path === "/cpd-submission") {
            dispatch(handleCPDCertificateStatus(CERTIFICATE_TYPE.PROFESSIONAL_TECHNOLOGIST));
        }
        dispatch(handleCurrentPage(1));
        dispatch(handleCurrentPageTableSlice(1));
        setOpenDropdown(false);
    };

    useEffect(() => {
        if (location.pathname.startsWith("/reports")) {
            setOpenDropdown(true);
        } else {
            setOpenDropdown(false);
        }

    }, [location]);

    useEffect(() => {
        if (location.pathname !== "/new-applicants") {
            dispatch(handleResetApplicationStatus());
            dispatch(handleCertificateStatus(21));
        }
        dispatch(setIDforStatusChange([]));
        dispatch(handleProfileInformationType(1))
    }, [location.pathname, dispatch]);

    return (
        <>
            <div id="wrapper">
                {/* Sidebar Container::start */}
                <aside className="sidebar-container d-none d-lg-flex">
                    {/* Sidebar Overlay::start */}
                    <div className="sidebar-overlay">
                        <img src={MBOTLogo} alt="MBOT Logo" className="overlay-header-logo" />
                        <div className="d-flex flex-column mt-3 cursor-pointer text-gray-250 fw-500 fs-6 sidebar-items gap-3">
                            {sidebarItems.map((item, index) => (
                                <div key={index}>
                                    {!item.children ? (
                                        <>
                                            <NavLink
                                                to={item.path}
                                                className={`text-decoration-none text-gray-250 ${location.pathname === item.path ? "active" : ""}`}
                                                activeClassName="active"
                                                onClick={() => handleItemClick(item.path)}
                                            >
                                                <div className="border_bottom" style={{ textWrap: "nowrap", padding: "5px 0px" }}>
                                                    <span>{item.name}</span>
                                                </div>
                                            </NavLink>
                                            {item.divider && <div className="after-line-title mt-3"></div>}
                                        </>
                                    ) : (
                                        <div className={`${openDropdown ? "children-dropdown-active" : ""}`}>
                                            <div className={`text-decoration-none text-gray-250`} onClick={handleDropdownClick} style={{ cursor: "pointer" }}>
                                                <div
                                                    className="border_bottom"
                                                    style={{
                                                        textWrap: "nowrap",
                                                        color: openDropdown ? "#29348f" : "",
                                                        fontWeight: openDropdown ? "bold" : "",
                                                    }}
                                                >
                                                    <span>{item.name}</span>
                                                    {item.divider && <div className="after-line-title mt-3"></div>}
                                                </div>
                                            </div>
                                            {openDropdown && (
                                                <div
                                                    className="dropdown-menu active"
                                                    style={{
                                                        flexDirection: "column",
                                                        background: "none",
                                                        border: "unset",
                                                        margin: "0px",
                                                    }}
                                                >
                                                    <div className={`text-decoration-none text-gray-250 child-div`}>
                                                        {item.children.map((child, childIndex) => (
                                                            <NavLink
                                                                key={childIndex}
                                                                to={child.path}
                                                                className={`text-decoration-none text-gray-250 ${location.pathname === child.path ? "active" : ""}`}
                                                                activeClassName="active"
                                                                style={{ background: "none" }}
                                                            >
                                                                <div className="border_bottom" style={{ textWrap: "nowrap" }}>
                                                                    <span>{child.name}</span>
                                                                </div>
                                                            </NavLink>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            ))}
                            <div className="dropdown" style={{ bottom: 0, position: "absolute", backgroundColor: "#fff" }}>
                                <div className="center-alignment cursor-pointer gap-2 account_profile" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <span>
                                        <img src={Account} alt="Account" />
                                        Account
                                    </span>
                                </div>
                                <ul className="dropdown-menu" style={{ border: "none" }}>
                                    <div onClick={handleLogOut} className="text-gray-300 center-alignment account_profile_logout cursor-pointer align-items-center flex-row">
                                        <MdOutlineLogout className="sidebar-item-icon" /> Logout 
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                </aside>
                {/* Page Content Section::start */}
                <section className="page-content">
                    {/* Navbar Container::start */}
                    <Navbar expand={false} className="nav-container d-lg-none">
                        <Container fluid className="flex-row-reverse flex-lg-row container-padding-nav">
                            <div className="d-flex align-items-baseline justify-content-between w-100 mb-2">
                                <Navbar.Brand className="pt-25">
                                    <img src={MBOTLogo} alt="MBOT Logo" className="img-fluid d-none d-lg-block" style={{ height: "40px" }} />
                                    <nav className="nav-container d-lg-block">
                                        <div className="p-0">
                                            <div className="d-flex main_navdiv">
                                                {/* <div className="formdata">
                                                    <Formik initialValues={initialValues}>
                                                        <Form>
                                                            <div className="search">
                                                                <span className="fa-search">
                                                                    <FaSearch />
                                                                </span>
                                                                <Field type="text" name="title" className="form-control" autoComplete="off" placeholder="Search Here.." />
                                                            </div>
                                                        </Form>
                                                    </Formik>
                                                </div> */}
                                                <div className="d-flex flex-div w-100 justify-content-center d-none d-sm-flex d-lg-none">
                                                    <div
                                                        style={{
                                                            visibility:
                                                                (location.pathname.includes("/dashboard") || location.pathname.includes("/reports") || location.pathname.includes("/cpd-submission")) &&
                                                                    !location.pathname.includes("/reports/interview-scheduled") &&
                                                                    !location.pathname.includes("/reports/export-reports")
                                                                    ? "visible"
                                                                    : "hidden",
                                                        }}
                                                    >
                                                        <DonwlodButton />
                                                    </div>
                                                    <div className="pl-75">
                                                        <DateRangePicker />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </nav>
                                </Navbar.Brand>
                                <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={() => setShowOffcanvas(true)} />
                            </div>
                            <div className="d-flex flex-div w-100 justify-content-center d-sm-none">
                                <div
                                    style={{
                                        visibility:
                                            (location.pathname.includes("/dashboard") || location.pathname.includes("/reports") || location.pathname.includes("/cpd-submission")) &&
                                                !location.pathname.includes("/reports/interview-scheduled") &&
                                                !location.pathname.includes("/reports/export-reports") ? "visible" : "hidden",
                                    }}
                                >
                                    <DonwlodButton />
                                </div>
                                <div className="pl-75">
                                    <DateRangePicker />
                                </div>
                            </div>
                            <Navbar.Offcanvas id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel" placement="end" show={showOffcanvas} onHide={() => setShowOffcanvas(false)}>
                                <Offcanvas.Header closeButton>
                                    <Offcanvas.Title id="offcanvasNavbarLabel">Menu</Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body>
                                    <Nav className="justify-content-end flex-grow-1 pe-3">
                                        {sidebarItems.map((item, index) => (
                                            <NavLink key={index} to={item.path} className="nav-link" onClick={() => setShowOffcanvas(false)}>
                                                {item.name}
                                            </NavLink>
                                        ))}
                                        <div onClick={handleLogOut} className="nav-link">
                                            <MdOutlineLogout /> Logout
                                        </div>
                                    </Nav>
                                </Offcanvas.Body>
                            </Navbar.Offcanvas>
                        </Container>
                    </Navbar>
                    <nav className="nav-container d-none d-lg-block">
                        <div className="napadding">
                            <div className="d-flex main_navdiv">
                                <div className="d-flex flex-div" style={{ justifyContent: location.pathname.includes("/dashboard") || location.pathname.includes("/reports") ? "end" : "end" }}>
                                    <div
                                        style={{
                                            visibility:
                                                (location.pathname.includes("/dashboard") || location.pathname.includes("/reports") || location.pathname.includes("/cpd-submission")) &&
                                                    !location.pathname.includes("/reports/interview-scheduled") &&
                                                    !location.pathname.includes("/reports/export-reports")
                                                    ? "visible"
                                                    : "hidden",
                                        }}
                                    >
                                        <DonwlodButton />
                                    </div>
                                    <div className="pl-75">
                                        <DateRangePicker />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                    {/* Main Content Start */}
                    <main className="main-content">
                        <Outlet />
                    </main>
                </section>
            </div>
        </>
    );
};

export default MasterLayout;
